<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
  import type { RecruitmentService } from "../../services/recruitment.service";
  import SearchFields from "./search/SearchFields.svelte";

  const label = "求人検索";

  export let service: RecruitmentService;

  onMount(async () => {
    await service.getList();
  });
</script>

<div class="flex">
  <SectionBoard>
    <h2 class="font-semibold">
      {label}
    </h2>

    <SearchFields klass="mt-4" {service} />
  </SectionBoard>
</div>
